// extracted by mini-css-extract-plugin
export default {"mainLayout":"main-layout_mainLayout__rxZnD","mainLayoutHeader":"main-layout_mainLayoutHeader__tX+SK","mainLayoutContent":"main-layout_mainLayoutContent__-Ij86"};